import portfolio from "../src/Projects_Img/portfolio.png";
export const data = {
  frontend: [
    {
      id: 1,
      title: "E-commerce Website",
      description:
        "A modern e-commerce website built with HTML, CSS, and JavaScript. Features include product listings, shopping cart, and checkout functionality.",
      image: {
        url: "https://example.com/ecommerce.png",
        alt: "E-commerce Website",
      },
    },
    {
      id: 2,
      title: "Portfolio Website",
      description:
        "A professional portfolio website showcasing skills, , and contact information. Developed using React.JS, and Tailwind CSS.",
      image: {
        url: portfolio,
        alt: "Portfolio Website",
      },
    },
    {
      id: 3,
      title: "Travel Blog",
      description:
        "A travel blog website designed with a clean and intuitive user interface. Implemented using HTML, CSS, and JavaScript.",
      image: {
        url: "https://example.com/travelblog.png",
        alt: "Travel Blog",
      },
    },
    {
      id: 4,
      title: "Social Media Dashboard",
      description:
        "A dashboard application for managing social media accounts. Built using HTML, CSS, JavaScript, and integrated with APIs.",
      image: {
        url: "https://example.com/dashboard.png",
        alt: "Social Media Dashboard",
      },
    },
    {
      id: 5,
      title: "Weather App",
      description:
        "An interactive weather application displaying current weather conditions. Developed with HTML, CSS, JavaScript, and APIs.",
      image: {
        url: "https://example.com/weatherapp.png",
        alt: "Weather App",
      },
    },
  ],
  backend: [
    {
      id: 6,
      title: "Task Management API",
      description:
        "A RESTful API for managing tasks and to-do lists. Implemented using Node.js, Express.js, and MongoDB.",
      image: {
        url: "https://example.com/taskapi.png",
        alt: "Task Management API",
      },
    },
    {
      id: 7,
      title: "Blog CMS",
      description:
        "A content management system (CMS) for publishing and managing blog posts. Built with Node.js, Express.js, and MongoDB.",
      image: {
        url: "https://example.com/blogcms.png",
        alt: "Blog CMS",
      },
    },
    {
      id: 8,
      title: "E-commerce REST API",
      description:
        "A robust RESTful API for handling e-commerce transactions and product management. Developed using Node.js, Express.js, and PostgreSQL.",
      image: {
        url: "https://example.com/ecommerceapi.png",
        alt: "E-commerce REST API",
      },
    },
    {
      id: 9,
      title: "Authentication Service",
      description:
        "A secure authentication service for user registration and login functionality. Created with Node.js, Express.js, and JWT authentication.",
      image: {
        url: "https://example.com/authservice.png",
        alt: "Authentication Service",
      },
    },
    {
      id: 10,
      title: "Real-time Chat Application",
      description:
        "A real-time chat application allowing users to communicate instantly. Built using Node.js, Socket.io, and MongoDB.",
      image: {
        url: "https://example.com/chatapp.png",
        alt: "Real-time Chat Application",
      },
    },
  ],
  react: [
    {
      id: 11,
      title: "Task Manager App",
      description:
        "A task management application built with React.js. Features include task creation, editing, and deletion.",
      image: {
        url: "https://example.com/taskmanager.png",
        alt: "Task Manager App",
      },
    },
    {
      id: 12,
      title: "Weather Dashboard",
      description:
        "A weather dashboard displaying current weather and forecasts. Developed using React.js and integrated with weather APIs.",
      image: {
        url: "https://example.com/weatherdashboard.png",
        alt: "Weather Dashboard",
      },
    },
    {
      id: 13,
      title: "Todo List Application",
      description:
        "A simple to-do list application created with React.js. Allows users to add, edit, and delete tasks.",
      image: {
        url: "https://example.com/todolist.png",
        alt: "Todo List Application",
      },
    },
    {
      id: 14,
      title: "Recipe Finder",
      description:
        "A recipe finder application built using React.js. Users can search for recipes based on ingredients and save favorites.",
      image: {
        url: "https://example.com/recipefinder.png",
        alt: "Recipe Finder",
      },
    },
    {
      id: 15,
      title: "Music Player",
      description:
        "A music player application with a sleek interface. Developed with React.js and integrated with music streaming APIs.",
      image: {
        url: "https://example.com/musicplayer.png",
        alt: "Music Player",
      },
    },
  ],
};

export const filterData = [
  {
    id: "1",
    title: "All",
  },
  {
    id: "2",
    title: "frontend",
  },
  {
    id: "3",
    title: "backend",
  },
  {
    id: "4",
    title: "react",
  },
];
